/**
 * InspectorPaneSlot — the RIGHT-pane content decision, shared by every surface
 * that renders the Inspector: the desktop three-pane row (CockpitLayout) and
 * the tablet/narrow-tablet/mobile slide-over (InspectorDrawer).
 *
 * Inspector pane is deal-focused: renders the full DealInspectorPane for
 * tracxn_livedeals and deal_screen, an empty-state hint for everything else.
 * Non-deal types render full detail inside the preview pane via the router.
 *
 * Extracted from CockpitLayout.jsx as part of the B1 fix
 * (WI-NIGHT-CLOSE-UI-RESTORE-AND-AMNESTY-STAGGER-001 Leg B): before this,
 * InspectorDrawer always rendered a bare DealInspectorPane regardless of
 * work_type, diverging from desktop's fallback-for-non-deal-types behaviour.
 * A dedicated file (rather than exporting from CockpitLayout.jsx, which
 * InspectorDrawer is imported BY) avoids a circular import between the two.
 *
 * Authority: WI-UI-CLEANUP-001 Stage 2 — CockpitLayout spec.
 */

import React from 'react';
import { DS_COLORS, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { COCKPIT_LABELS, WORK_TYPES } from '@/config/task-display-config';
import DealInspectorPane from './DealInspectorPane';

const DEAL_INSPECTOR_WORK_TYPES = new Set([
  WORK_TYPES.TRACXN_LIVEDEALS,
  WORK_TYPES.FIRST_LOOK,
  WORK_TYPES.DEAL_SCREEN,
]);

export function InspectorPaneSlot({ selected, onRefresh }) {
  if (!selected || DEAL_INSPECTOR_WORK_TYPES.has(selected.work_type)) {
    return <DealInspectorPane selected={selected} onRefresh={onRefresh} />;
  }
  return (
    <div
      data-testid="inspector-non-deal-fallback"
      role="region"
      aria-label={COCKPIT_LABELS.aria.inspector}
      style={{
        width: 320,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: DS_COLORS.surface.white,
        borderLeft: `1px solid ${DS_COLORS.border.default}`,
      }}
    >
      <p
        style={{
          ...DS_TYPOGRAPHY.bodySm,
          color: DS_COLORS.text.muted,
          margin: 0,
          textAlign: 'center',
        }}
      >
        {COCKPIT_LABELS.emptyState.inspectorNonDeal}
      </p>
    </div>
  );
}

export default InspectorPaneSlot;
